







on_clickaway = require('vue-clickaway')
exports.default =
  mixins: [ on_clickaway.mixin ]
  props:      
    id: 
      type: Number
      default: ''
  data: ->

    selected: null
    selected_items: []
    default_label: null
    list: []
    show_list: false;

  watch: 
    selected: ->
      @$emit 'selected', @selected
  methods:
    successCallback: (response)->
      len = response.custom_fields.length
      for x in [0..len-1]
        if response.custom_fields[x]['kind'] == 'dropdown'
          if response.custom_fields[x]["id"] == @id 
            @selected = response.custom_fields[x]["field"]
          @list.push(response.custom_fields[x]["field"])
    clickList: ->
      @show_list = !@show_list

    clicked: ()->
      @$store.commit 'table', @selected

    onClickaway: ->
      if @show_list
        @show_list = false

  created: ->
    params = {
      q: {
          kind_eq: 'dropdown'
      }
    }
    new CustomFieldsResource().index(@successCallback, null, params)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/integrations/properties_select.vue